// extracted by mini-css-extract-plugin
export default {"normal":"N5P5ZN","roman":"T2_JNo","bold":"zQwdZ5"};